export const clearSuperAdminDashboardCache = () => {
    try {
        Object.keys(localStorage)
            .filter((key) => key.startsWith('sa_') && key !== 'sa_includeGroup')
            .forEach((key) => localStorage.removeItem(key));
    } catch {
        // localStorage 접근 실패는 화면 갱신을 막지 않는다.
    }
};

export const invalidateSuperAdminDashboardQueries = async (queryClient: any) => {
    clearSuperAdminDashboardCache();
    await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['superAdminOverview'] }),
        queryClient.invalidateQueries({ queryKey: ['superAdminTrainerOverview'] }),
        queryClient.invalidateQueries({ queryKey: ['superAdminRevenueTrend'] }),
        queryClient.invalidateQueries({ queryKey: ['superAdminRefundAnalysis'] }),
        queryClient.invalidateQueries({ queryKey: ['superAdminDetailOverview'] }),
        queryClient.invalidateQueries({ queryKey: ['centerRevTrend'] }),
        queryClient.invalidateQueries({ queryKey: ['superAdminKpi'] }),
    ]);
};
